import React, {Component, Fragment, PureComponent} from 'react';

import {ListView, Button, Toast, Modal, WhiteSpace} from 'antd-mobile';
import {connect} from 'react-redux';
import {getConsumeList} from './store/actionCreators';
import {formatDate} from '../../utils/common';
import history from './../../utils/history';

import PublicHeader from './../../components/header/index';

let pageIndex = 0;
const alert = Modal.alert;


class MyConsume extends PureComponent {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
        };
    }

    componentDidMount() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }

        this.props.getConsumeList(pageIndex);

        setTimeout(() => {
            this.setState({
                isLoading: false,
            });
        }, 600);
    }

    async refund(orderId) {
        console.log(orderId)
        const data = {
            orderId: orderId,
        };
        const result = await this.props.refund(data);
        if (result.data.success === false) {
            Toast.info(result.data.error);
        } else {
            Toast.info("退款成功！");
        }
        window.location.reload();
        return result;
    }

    onEndReached = (event) => {
        debugger
        const {consumeList} = this.props;
        const {data = [], total} = consumeList;

        if (data.length >= total) {
            this.setState({hasMore: false});
        } else {
            setTimeout(() => {
                this.setState({hasMore: false}, () => {
                    this.currentPage = ++this.currentPage;
                    this.props.getConsumeList(++pageIndex).then(() => {
                        this.setState({hasMore: true});
                    });
                });
            }, 200);
        }
    }


    render() {
        const {consumeList} = this.props;
        const {data = [{}]} = consumeList;

        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED',
                    borderBottom: '1px solid #ECECED',
                }}
            />
        );
        const renderRow = (rowData, rowID) => {
            if (JSON.stringify(rowData) == "{}") {
                return (<div>
                    <div className="user-recharge" style={{textAlign: "center", padding: "15px", color: "#888"}}>
                        暂无消费记录
                    </div>
                </div>);
            }
            const obj = rowData;
            const {siteDTO = {}, venue = {}} = obj;
            console.log(obj)
            return (
                <div key={rowID} style={{padding: '0 15px'}}>

                    <div class="div-header">{venue.name} </div>

                    <div class="div-footer">
                    </div>
                </div>
            );
        };

        return (
            <Fragment>
                <PublicHeader title="消费记录"/>

                <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource.cloneWithRows(data)}
                    renderFooter={() => (<div style={{padding: 30, textAlign: 'center'}}>
                        {this.state.isLoading ? '加载中...' : '已经到底啦～'}
                    </div>)}
                    renderRow={(rowData, id1, i) => renderRow(rowData, i)}
                    renderSeparator={separator}
                    className="am-list"
                    pageSize={4}
                    useBodyScroll
                    onScroll={() => {
                        console.log('scroll');
                    }}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (data) => {
    console.log(data)
    return {
        consumeList: data.consume.consumeList
    }
};

const mapDispatchToProps = (dispatch) => ({
    getConsumeList: (pageIndex) => dispatch(getConsumeList({pageNo: pageIndex, size: 10})),
});
export default connect(mapStateToProps, mapDispatchToProps)(MyConsume);
